module.exports = __webpack_public_path__ + "img/p15.dab62e8a.png";